(function () {
    "use strict";

    angular.module("app").component("habilInvalidRemarkView", {
        template: `
            <div class="row">
                <p class="pull-left">
                    <i class="fa fa-exclamation-circle"></i>&nbsp;<strong i18n="Reason_NSA_SendBack"></strong>
                </p>
                <pre class="form-control"
                     style="background-color: rgb(242, 222, 222);
                            resize: vertical;
                            display: inline-block;
                            height: auto;"
                     ng-bind-html="$ctrl.remark">
                </pre>
            </div>`,
        bindings: { remark: "=", },
    });

})();
